<ion-app class="menu-container">
  <div class="ion-page">
    <ion-header *ngIf="showMenu" class="ion-no-border">
      <ion-toolbar color="primary">
        <div class="header-container">
          <div class="container-logo cursor-pointer" >
            <ion-icon name="menu-outline" (click)="startMenu()"></ion-icon>
          </div>

          <div class="ion-text-center profile">
            <div class="notifications cursor-pointer">
              <a class="cart"  [routerLink]="['/notifications']" title="Facebook"  rel="nofollow">
                <img src="/assets/img/notifications-outline.svg" width="30px" />
                <span
                  id="cart_menu_num"
                  data-action="cart-can"
                  class="badge rounded-circle"
                  >{{countAlerts}}</span
                >
              </a>
            </div>

            <div
              class="rol-container"
              *ngIf="this.userInfo"
              (click)="presentPopover($event)"
            >
              <span class="rol-information"
                >{{ this.userInfo.first_name | titlecase }}
                {{ this.userInfo.last_name | titlecase }}
              </span>
              <!-- <ion-avatar >
                <img
                  src="/assets/img/profile-default.webp"
                  width="50px"
                  height="50px"
                />
              </ion-avatar> -->

              <div class="profile-icon">
                <p class="ion-text-center" aria-disabled="true">
                  {{
                    getInitials(
                      this.userInfo.first_name + " " + this.userInfo.last_name
                    )
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="menu-content" *ngIf="openMenu && showMenu && hasLicense">
        <div class="sidebar">
          <a
            class="menu-option"
            *ngFor="let option of menu"
            [routerLink]="[option.route]"
            (click)="openMenu = false"
            [hidden]="!showOption(option)"
            routerLinkActive="menu-option-active"
          >
            <div class="icons-container">
              <img [src]="option.icon" class="option-icon" />
              <span>{{ option.label }}</span>
            </div>
          </a>

          <div class="logo-tasko">
            <img src="assets/img/taskgo-powered-by.svg" />
          </div>
        </div>
      </div>
      <div class="dashboard overflow-auto">
        <ion-router-outlet
          [ngClass]="{ 'container-menu': showMenu && openMenu && hasLicense }"
          class="background-content-default"
          [ngStyle]="{
            'margin-left': showMenu && openMenu && hasLicense? '234px' : '0',
            'border-top-left-radius': showMenu && openMenu && hasLicense? '30px' : '0'
          }"
        ></ion-router-outlet>
      </div>
    </ion-content>
  </div>
  <ion-popover
    #popoverProfile
    [isOpen]="isOpen"
    (didDismiss)="isOpen = false"
    class="mt-4"
    [showBackdrop]="false"
  >
    <ng-template>
      <ion-content (click)="logout()">
        <ion-item color="primary">
          <div class="content-item">
            <ion-icon
              slot="start"
              name="log-out-outline"
              class="log-out-icon"
            ></ion-icon>
            <ion-label class="cursor-pointer"> Cerrar Sesión</ion-label>
          </div>
        </ion-item>
      </ion-content>
    </ng-template>
  </ion-popover>
</ion-app>
